export default {
    id: 'indicators',
    afterDraw(chart) {
        const metas = chart.getSortedVisibleDatasetMetas()
        for (let i = 0; i < metas.length; i++) {
            const meta = metas[i]
            if (meta._pt) {
                meta._pt.draw(chart.ctx)
            }
        }
    },
    afterEvent(chart, args) {
        if (args.event.type === 'mouseout') {
            const metas = chart.getSortedVisibleDatasetMetas()
            for (let i = 0; i < metas.length; i++) {
                metas[i]._pt = null
            }
            args.changed = true
        }
    }
}
